import { FormType } from '@aloft/toolkit-shared';
import { Flex, RadioGroup } from '@aloft/toolkit-sui';

import { Typography } from '../../summary/components/Typography.tsx';
import { ExportModalExportTypes } from './ExportModalExportTypes.tsx';
import { ClickFormsExisting, ExportType } from './types.ts';

export const ExportModalContent = ({
  exportType,
  setExportType,
  clickFormsExisting,
  setClickFormsExisting,
  formType,
  setFormType,
  includeAnnotations,
  setIncludeAnnotations,
}: {
  exportType?: ExportType;
  setExportType: (val: ExportType) => void;
  clickFormsExisting?: ClickFormsExisting;
  setClickFormsExisting: (val?: ClickFormsExisting) => void;
  formType: FormType;
  setFormType: (val: FormType) => void;
  includeAnnotations: boolean;
  setIncludeAnnotations: (val: boolean) => void;
}) => {
  const items: { label: string; value: ExportType }[] = [
    { label: 'PDFs', value: 'pdf' },
    { label: 'Total (.tdcx)', value: 'total' },
    { label: 'Appraise-it Pro (.rpti)', value: 'appraise-it' },
    { label: 'ClickFORMS (.txt)', value: 'click-forms' },
  ];

  const handleExportTypeChange = (val: ExportType) => {
    setClickFormsExisting(undefined);
    setFormType(formType);
    setExportType(val);
  };

  return (
    <Flex flexDirection="column" gap="1rem">
      <Typography variant="h1">Export</Typography>
      <RadioGroup
        label="What would you like to export?"
        size="lg"
        gap=".5rem"
        items={items}
        value={exportType}
        onChange={(val) => handleExportTypeChange(val as ExportType)}
      />
      <ExportModalExportTypes
        exportType={exportType}
        clickFormsExisting={clickFormsExisting}
        setClickFormsExisting={setClickFormsExisting}
        formType={formType}
        setFormType={setFormType}
        includeAnnotations={includeAnnotations}
        setIncludeAnnotations={setIncludeAnnotations}
      />
    </Flex>
  );
};
